import React, { useContext } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ThemeProvider } from "@material-tailwind/react";

// contexts
import UserInfoContext from "./contexts/UserInfoContext";

// css
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "react-loading-skeleton/dist/skeleton.css"
import "swiper/css/zoom";
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import "./css/index.css";
import "./css/styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <UserInfoContext>
    <BrowserRouter>
    <ThemeProvider>
      <App />
    </ThemeProvider>
    </BrowserRouter>
  </UserInfoContext>
);
